module.exports = __webpack_public_path__ + "img/regis_h.c836708b.png";